/**
 * 线路配置模块 API 封装
 */

import { request } from '../core';
import { PageType } from '@/utils/enum';
import { CommonResponse, CommonTableResponse } from '@/types/interface';
import type {
  SearchCondition,
  RouteConfigRequest,
  RouteConfigDetail,
  RouteListItem,
  StationOption,
  StopItem,
} from '@/views/RouteConfig/utils/type';

type StationUseCase = 'OPEN_OPERATION' | 'AIR_GROUND_DISTRIBUTE';

export class RouteConfigApi {
  /**
   * 分页查询线路列表
   */
  fetchRouteList({
    pageNum,
    pageSize,
    searchForm,
  }: SearchCondition): Promise<
    CommonResponse<CommonTableResponse<RouteListItem>>
  > {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/airLand/scheduleRoute/page',
      body: { ...searchForm, pageNum, pageSize },
    };
    return request(options);
  }

  /**
   * 查询线路详情
   */
  fetchRouteDetail(
    routeId: number,
  ): Promise<CommonResponse<RouteConfigDetail>> {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/airLand/scheduleRoute/getById',
      body: { routeId },
    };
    return request(options);
  }

  /**
   * 新增/编辑线路
   */
  submitRoute({
    type,
    requestBody,
  }: {
    type: PageType.EDIT | PageType.ADD;
    requestBody: RouteConfigRequest;
  }): Promise<CommonResponse<any>> {
    const options: RequestOptions = {
      method: 'POST',
      path:
        type === PageType.EDIT
          ? '/k2/management/airLand/scheduleRoute/updateRoute'
          : '/k2/management/airLand/scheduleRoute/addRoute',
      body: requestBody,
    };
    return request(options);
  }

  /**
   * 删除线路
   */
  deleteRoute(routeId: number): Promise<CommonResponse<any>> {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/airLand/scheduleRoute/deleteRoute',
      body: { routeId },
    };
    return request(options);
  }

  /**
   * 获取站点列表（用于站点和分拣中心选择）
   */
  getStationList(
    useCase: StationUseCase,
  ): Promise<CommonResponse<StationOption[]>> {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/common/getStationList',
      body: { useCase },
    };
    return request(options);
  }

  /**
   * 获取停靠点列表（根据站点ID）
   * 返回值：{ id, name, standName }
   * 示例：{ id: 123, name: "DOCK_001", standName: "分拣中心东侧停靠区" }
   */
  getStopsFromStation(
    stationBaseId: number,
  ): Promise<CommonResponse<StopItem[]>> {
    const options: RequestOptions = {
      method: 'POST',
      path: '/k2/management/deployment/stop/getRouteStopList',
      body: { stationId: stationBaseId },
    };
    return request(options);
  }
}

export default new RouteConfigApi();
